import { useEffect, useState } from "react";
import { apiClient } from "@/lib/api";

export default function AdminTaxReport() {
  const [report, setReport] = useState(null);

  useEffect(() => {
    apiClient.get("/admin/tax-report").then((res) => setReport(res.data));
  }, []);

  if (!report) return <div className="h-40 bg-white rounded-md animate-pulse" data-testid="admin-tax-report-loading" />;

  return (
    <div data-testid="admin-tax-report-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-display font-semibold text-slate-900">Sales Tax Report</h1>
        <span className="text-sm text-slate-500" data-testid="tax-report-total">
          Total collected: <span className="font-bold text-slate-900">${report.total_tax_collected.toFixed(2)}</span>
        </span>
      </div>
      <p className="text-xs text-slate-500 mb-4">Tax collected on paid, non-cancelled orders, grouped by shipping state. Use this at filing time.</p>

      <div className="bg-white border border-slate-200 rounded-md shadow-sm overflow-x-auto">
        <table className="w-full text-sm text-slate-600">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
            <tr>
              <th className="px-4 py-3">State</th>
              <th className="px-4 py-3">Rate</th>
              <th className="px-4 py-3">Paid Orders</th>
              <th className="px-4 py-3">Taxable Sales</th>
              <th className="px-4 py-3 text-right">Tax Collected</th>
            </tr>
          </thead>
          <tbody>
            {report.rows.map((r) => (
              <tr key={r.state} className="border-t border-slate-100" data-testid={`tax-report-row-${r.state}`}>
                <td className="px-4 py-3 font-semibold text-slate-900">{r.state}</td>
                <td className="px-4 py-3">{r.rate.toFixed(0)}%</td>
                <td className="px-4 py-3">{r.orders}</td>
                <td className="px-4 py-3">${r.taxable_sales.toFixed(2)}</td>
                <td className="px-4 py-3 text-right font-bold text-slate-900">${r.tax_collected.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {report.rows.length === 0 && <p className="p-6 text-center text-slate-400 text-sm" data-testid="tax-report-empty">No tax collected yet — rows appear as paid orders come in.</p>}
      </div>
    </div>
  );
}
